import React from 'react';
import { FiMonitor, FiCheck, FiAlertCircle } from 'react-icons/fi';
import useDesktopPwaStatus from '../hooks/useDesktopPwaStatus';
import DesktopAppInstallCta from './marketing/DesktopAppInstallCta';

const STATUS_LABEL = {
  'running-app': 'App de escritorio activa',
  installed: 'Instalada en este equipo',
  'not-installed': 'No instalada',
  'local-dev': 'Instalar desde producción',
  'local-dev-installed': 'App atada a localhost',
  mobile: 'Usá una computadora',
};

function StatusBadge({ kind, modoOscuro }) {
  const styles = {
    'running-app': modoOscuro
      ? 'border-emerald-800 bg-emerald-950/50 text-emerald-300'
      : 'border-emerald-200 bg-emerald-50 text-emerald-800',
    installed: modoOscuro
      ? 'border-emerald-800 bg-emerald-950/50 text-emerald-300'
      : 'border-emerald-200 bg-emerald-50 text-emerald-800',
    'not-installed': modoOscuro
      ? 'border-gray-600 bg-gray-800/80 text-gray-300'
      : 'border-gray-200 bg-gray-50 text-gray-600',
    'local-dev': modoOscuro
      ? 'border-amber-800 bg-amber-950/50 text-amber-200'
      : 'border-amber-200 bg-amber-50 text-amber-900',
    'local-dev-installed': modoOscuro
      ? 'border-amber-800 bg-amber-950/50 text-amber-200'
      : 'border-amber-200 bg-amber-50 text-amber-900',
    mobile: modoOscuro
      ? 'border-gray-600 bg-gray-800/80 text-gray-400'
      : 'border-gray-200 bg-gray-100 text-gray-500',
  };
  const Icon = kind === 'not-installed' ? FiAlertCircle : FiCheck;
  return (
    <span
      className={`shrink-0 inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${styles[kind] || styles['not-installed']}`}
      role="status"
    >
      <Icon className="w-3.5 h-3.5" aria-hidden />
      {STATUS_LABEL[kind] || STATUS_LABEL['not-installed']}
    </span>
  );
}

const CuentaDesktopInstallPanel = ({ box, textPri, textMuted, modoOscuro }) => {
  const { loading, kind } = useDesktopPwaStatus();

  const borderB = modoOscuro ? 'border-gray-700' : 'border-gray-200';
  const iconBox = modoOscuro ? 'border-gray-600 bg-gray-800' : 'border-gray-300 bg-white';

  return (
    <div id="app-escritorio" className={`xl:col-span-2 ${box} rounded-2xl border overflow-hidden`}>
      <div className={`px-4 py-3 border-b ${borderB}`}>
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <div className={`w-9 h-9 rounded-xl border flex items-center justify-center shrink-0 ${iconBox}`}>
              <FiMonitor className={`text-base ${modoOscuro ? 'text-gray-300' : 'text-gray-900'}`} />
            </div>
            <div className="min-w-0">
              <h2 className={`text-sm font-semibold ${textPri}`}>App de escritorio</h2>
              <p className={`text-xs ${textMuted}`}>Misma instalación que en la página de inicio (Chrome o Edge).</p>
            </div>
          </div>
          {!loading && <StatusBadge kind={kind} modoOscuro={modoOscuro} />}
        </div>
      </div>

      <div className="p-4 sm:p-5">
        <DesktopAppInstallCta variant="account" modoOscuro={modoOscuro} />
      </div>
    </div>
  );
};

export default CuentaDesktopInstallPanel;
